/* global Promise */
'use strict';

var httpClient = require('./httpClient').httpClient;
/**
 * Makes an ajax call to the controller function FetchGiftCards.
 * Never rejects: a failed/invalid response falls back to an empty gift card state
 * so the main payment methods can still mount.
 * @returns {Promise} - The promise object
 */
function fetchGiftCards() {
    return httpClient({
        method: 'POST',
        url: window.fetchGiftCardsUrl
    }).then(function (data) {
        if (!data || typeof data !== 'object' || Array.isArray(data)) {
            throw new Error('Invalid fetchGiftCards response');
        }
        return data;
    }).catch(function (error) {
        // eslint-disable-next-line no-console
        console.warn('fetchGiftCards failed, continuing without gift cards', error);
        return { giftCards: [] };
    });
}

/**
 * Makes an ajax call to the controller function GetPaymentMethods
 * @returns {Promise} - The promise object
 */
function getPaymentMethods() {
    return httpClient({
        method: 'POST',
        url: window.getPaymentMethodsURL
    });
}

/**
 * Makes an ajax call to the controller function GetExpressPaymentMethods
 * @returns {Promise} - The promise object
 */
function getExpressPaymentMethods() {
    return httpClient({
        method: 'POST',
        url: window.getExpressPaymentMethodsURL
    });
}

function getConnectedTerminals() {
    return $.ajax({
        url: window.getConnectedTerminalsURL,
        type: 'post',
        data: {
            csrf_token: $('#adyen-token').val(),
            data: JSON.stringify({
                storeId: $('#storeList').val()
            })
        }
    });
}

/**
 * Makes an ajax call to the controller function createTemporaryBasket
 * @returns {Promise} - The promise object
 */
function createTemporaryBasket() {
    var productForm = document.getElementById('express-product-form');
    if (!productForm) {
        return Promise.reject(new Error('Product form not found'));
    }

    var data = new FormData(productForm);
    var parsedData = {};

    // Fallback for Object.fromEntries which is ES2019+
    var it = data.entries();
    var entry = it.next();
    while (!entry.done) {
        if (entry.value[0] === 'selected-express-product') {
            parsedData = JSON.parse(entry.value[1]);
            break;
        }
        entry = it.next();
    }

    return httpClient({
        method: 'POST',
        url: window.createTemporaryBasketUrl,
        data: {
            data: JSON.stringify({
                id: parsedData.id,
                bundledProducts: parsedData.bundledProducts,
                options: parsedData.options,
                selectedQuantity: parsedData.selectedQuantity
            })
        }
    });
}

/**
 * Makes an ajax call to the controller function calculatePrice
 * @param {string} productId - The product ID
 * @param {number} quantity - The quantity
 * @returns {Promise} - The promise object
 */
function calculateProductPrice(productId, quantity) {
    return httpClient({
        method: 'POST',
        url: window.productPriceCalculateUrl,
        data: {
            pid: productId,
            quantity: quantity
        }
    });
}

module.exports = {
    fetchGiftCards: fetchGiftCards,
    getPaymentMethods: getPaymentMethods,
    getExpressPaymentMethods: getExpressPaymentMethods,
    getConnectedTerminals: getConnectedTerminals,
    createTemporaryBasket: createTemporaryBasket,
    calculateProductPrice: calculateProductPrice
};
